<template>
    <div id="main">
        <div class="page">
            <container-loader v-if="isLoading && !$store.getters.isLoading" />
            <div class="vertical-flow">
                <div class="listing-header">
                    <div class="title-breadcrumb">
                        <h1 class="title">
                            {{ $t('vincular-grupo') }}
                        </h1>
                    </div>
                    <div class="header-buttons">
                        <button
                            class="delete-btn"
                            type="button"
                            tag="button"
                            @click="$emit('voltar', true)"
                        >
                            {{ $t('voltar') }}
                        </button>
                        <button 
                            class="save-btn" 
                            type="button" 
                            @click="save" 
                            :disabled="isSaving">
                                {{ $t('salvar') }}
                            <svg class="svg-loader" v-if="isSaving">
                                <use :xlink:href="require('@/assets/img/icons/loader.svg')+'#layer'"></use>
                            </svg>
                        </button>
                    </div>
                </div>
                <div class="form-columns-fit">
                    <div class="columns is-flex-wrap">
                    <div class="column is-3">
                        <v-input
                            v-model="regraDesconto.tipoRegraProduto"
                            placeholder="regra-desconto"
                            :maxlength="50"
                            :title="'regra-desconto'"
                            disabled
                            :msg="'msg-campo-obrigatorio'"
                            :invalid="!regraDesconto.tipoRegraProduto"
                            uppercase/>
                    </div>
                    <div class="column is-3">
                        <v-input
                            v-model="inicio"
                            placeholder="inicio"
                            :maxlength="50"
                            :title="'inicio'"
                            :required="true"
                            :msg="'msg-campo-obrigatorio'"
                            :invalid="!inicio"
                            uppercase/>
                    </div>
                    <div class="column is-3">
                        <v-input
                            v-model="fim"
                            placeholder="fim"
                            :maxlength="50"
                            :title="'fim'"
                            :required="true"
                            :msg="'msg-campo-obrigatorio'"
                            :invalid="!fim"
                            uppercase/>
                    </div>
                    <div class="column is-3">
                        <v-input
                            v-model="valor"
                            placeholder="valor"
                            :maxlength="50"
                            :title="'valor'"
                            :required="true"
                            :msg="'msg-campo-obrigatorio'"
                            :invalid="!valor"
                            uppercase/>
                    </div>
                    <div class="column is-3">
                        <v-input
                            v-model="descontoMaximo"
                            placeholder="desconto-permitido"
                            :maxlength="50"
                            :title="'desconto-permitido'"
                            :required="true"
                            :msg="'msg-campo-obrigatorio'"
                            :invalid="!descontoMaximo"
                            uppercase/>
                    </div>
                </div>
            </div>
            <div class="column is-12">
                <search-bar :onSearch="debouncedOnSearch" tooltipLabel="msg-campo-busca-forma-pagamento-descricao" />
            </div>
                <empty-table-message v-if="isEmpty" />
                <b-table
                    v-else
                    :data="grupos"
                    class="data-table"
                    @sort="sortTable"
                    backend-sorting
                    checkable
                    :checked-rows.sync="gruposSelecionados"
                    :custom-is-checked="(selecionados, linha) => selecionados.id === linha.id">
                    <b-table-column
                        v-for="(f, i) in fields"
                        :key="i"
                        :field="f.key"
                        :label="$t(f.key)"
                        :width="f.width"
                        :sortable="f.sortable"
                        :visible="f.visible"
                        :custom-sort="f.sortFn"
                        v-slot="props">
                        <div>
                            {{ props.row[f.key] }}
                        </div>
                    </b-table-column>
                </b-table>
                <PaginationViewer
                    class="mb-0"
                    :resetPagination="pagination.resetPagination"
                    :totalItems="pagination.totalRows"
                    :perPageOptions="pagination.perPageOptions"
                    :optionStarted="pagination.optionStarted"
                    @change="updatePagination"
                />
            </div>
        </div>
    </div>
</template>

<script>
import ContainerLoader from '@/components/content/loader/ContainerLoader';
import GrupoProdutoService from '@/services/GrupoProdutoService';
import RegrasDescontoItemService from '@/services/RegrasDescontoItemService';
import Message from "@/models/Message";

export default {
    components: {
        Message,
        ContainerLoader,
    },
    props: {
        regraDesconto: {
            type: Object,
            default: {},
        },
    },
    data() {
        return {
            grupos: [],
            gruposSelecionados: [],
            service: new GrupoProdutoService(this.$http, this.$router),
            serviceItemDesconto: new RegrasDescontoItemService(this.$http, this.$router),
            fields: [
                { key: 'codigo', sortable: true, sortFn: null, visible: true },
                { key: 'grupo', width: 800, sortable: true, sortFn: null, visible: true }
            ],
            pagination: {
                resetPagination: false,
                perPageOptions: [10, 25, 50, 100],
                optionStarted: 0,
                perPage: null,
                totalRows: 0,
                currentPage: 1,
            },
            inicio: 0,
            fim: 0,
            valor: 0,
            descontoMaximo: 0,
            isSaving: false,
            tabPreco:{},
            isLoading: false,
            isEmpty: true,
            debouncedOnSearch: null,
            queryFilter: '',
            column: 'descricao',
            order: 'asc',
        };
    },
    created() {
        this.pagination.perPage = this.pagination.perPageOptions[this.pagination.optionStarted];
        this.debouncedOnSearch = this.debounce(this.onSearch, 500);

        this.tabPreco = {
            id: this.regraDesconto.tabelaPreco.id, 
            label: this.regraDesconto.tabelaPreco.descricao
        }

        this.carregarDados();
    },
    methods: {
        onSearch(value) {
            this.queryFilter = this.removeAcentos(value);
            this.pagination.currentPage = 1;
            this.carregarDados();
        },
        updatePagination(value) {
            this.pagination.resetPagination = false;
            this.pagination.perPage = value.perPage;
            this.pagination.currentPage = value.currentPage;
            this.carregarDados(value.currentPage);
        },
        save() {
            const politicaDesconto = this.mapOnSave();
            //if (this.validation.validate(politicaDesconto, this.$refs)) {
                this.serviceItemDesconto
                    .insertBulk(politicaDesconto)
                    .then((value) => {
                        if (value.status == 200) {
                            this.msgs.push(new Message("success", "msg-save-situacao", true));
                        }
                    })
                    .catch((e) => {
                        this.msgs.push(new Message("alert", e.message, true));
                    })
                    .finally(() => {
                        this.isSaving = false;
                        this.isLoading = false;
                        this.isLoadingEdit = false;
                    });
            //} else {                
                this.$root.msgs.push(new Message("alert", 'msg-campos-obrigatorios', true));
                this.isLoading = false;
            //}
        },
        mapOnSave(){
            return {
                idVenPoliticaDesconto: this.regraDesconto.id,
                venPoliticaDescontoItemList: this.gruposSelecionados.map((item)=>{
                    return {
                        idGrupoProduto: item.id,
                        idProduto: 0,
                        inicio: this.inicio,
                        fim: this.fim,
                        valor: this.valor,
                        decontoMaximo: this.descontoMaximo,
                        regrasDesconto: 0
                    }
                })
            }
        },
        carregarDados(currentPage = 1) {
            if (currentPage == 1 && this.pagination.currentPage != 1)
                this.pagination.resetPagination = true;
            this.isLoading = true;
            const sort = {
                column: this.column,
                order: this.order
            }
            this.service
                .findAllNaoVinculadoRegraDesconto(
                    currentPage - 1,
                    this.pagination.perPage,
                    sort,
                    this.regraDesconto.id,
                    this.queryFilter
                )
                .then(this.mapItems)
                .then((value) => {
                    this.grupos = value;
                    this.isEmpty = this.grupos.length <= 0;
                })
                .catch((e) => {
                    this.isEmpty = true;
                    this.$root.showMessage('error', 'msg-erro-load');
                    console.error('Erro ao carregar os prazos.');
                })
                .finally((_) => {
                    this.isLoading = false;
                    this.pagination.resetPagination = false;
                });
        },
        mapItems(body) {
            this.pagination.totalRows = body.totalElements;
            let gplist = [];
            if (body.content) {
                gplist = body.content.map((gp) => {
                    return {
                        id: gp.idgrupoproduto,
                        codigo: gp.idgrupoprodutoerp,
                        grupo: gp.descricao,
                    };
                });
            }
            return gplist;
        },
        sortTable(field, order) {
            this.column = field;
            this.order = order;
            this.carregarDados();
        },
    },
};
</script>

<style lang="scss" scoped>
#main {
    background-color: $bg-color;
    border-radius: 5px;
    padding: 5px 20px;
    height: 100%;

    .page {
        padding-left: 0;
        .table-tag {
            width: 5rem !important;
        }
    }
}
</style>
